import { W as WuiCheckInputGroup$1, d as defineCustomElement$1 } from './p-C_Ax2G7l.js';

const WuiCheckInputGroup = WuiCheckInputGroup$1;
const defineCustomElement = defineCustomElement$1;

export { WuiCheckInputGroup, defineCustomElement };
